import { Box, Flex } from "@chakra-ui/layout";
import history from "infra/helpers/history";
import { useBreadcrumb } from "features/breadcrumbs";
import DashboardAcordos from "./components/DashboardAcordos";
import useListagemAcordoColumns from "./hooks/useListagemAcordoColumns";
import NewTable from "components/NewTable";
import useAcordos from "features/acordo/hooks/useAcordos";
import Container from "components/Container";
import PageHeader from "components/Page/PageHeader";
import useFiltroAcordos from "./hooks/useFiltroAcordos";
import { AcordoItem } from "core/features/acordo/typings";
import HeaderTable from "components/Page/HeaderTable";
import TagsAcordos from "./components/TagsAcordos/index";
import useDashboardAcordos from "core/features/acordo/hooks/useDashboardAcordos";
import DateRangePicker from "components/Input/DateRangePicker/index";

function AcordoListagemPage() {
  const { filtro, onChangeFiltro } = useFiltroAcordos();
  const { data, isLoading } = useAcordos(filtro);
  const {
    data: dashboard,
    isLoading: isLoadingDashboard,
    isFetching: isFetchingDashboard,
  } = useDashboardAcordos(filtro);

  useBreadcrumb([{ name: "Financeiro" }, { name: "Acordos" }]);

  const columns = useListagemAcordoColumns();

  return (
    <Container>
      <Flex mb="16px">
        <PageHeader
          title="Acordos"
          midComponent={
            <DateRangePicker
              placeholder="Filtrar por período"
              onChange={(dataInicio, dataFim) => {
                onChangeFiltro({
                  dataInicio,
                  dataFim,
                });
              }}
              value={{
                dataInicio: filtro.dataInicio,
                dataFim: filtro.dataFim,
              }}
            />
          }
        />
      </Flex>

      <Box mb={6}>
        <DashboardAcordos
          data={dashboard}
          isLoading={isLoadingDashboard || isFetchingDashboard}
          onCardClick={(status) => onChangeFiltro({ status })}
        />
      </Box>

      <Box>
        <NewTable<AcordoItem>
          title={() => (
            <Flex gridGap="16px">
              <Flex w="350px">
                <HeaderTable
                  value={filtro.search || ""}
                  onSearch={(search?: string) => onChangeFiltro({ search })}
                />
              </Flex>

              <TagsAcordos
                status={filtro.status}
                onChangeStatus={(status) => onChangeFiltro({ status })}
              />
            </Flex>
          )}
          loading={isLoading}
          columns={columns}
          onRow={(item) => ({
            onClick: () => {
              history.push(`/financeiro/receita/acordo/${item.id}`);
            },
            style: {
              cursor: "pointer",
            },
          })}
          dataSource={data?.items ?? []}
          customPagination={{
            onChangePage: (page, perPage) =>
              onChangeFiltro({ page, limit: perPage }),
            currentPage: data?.meta.currentPage ?? 0,
            itemsPerPage: data?.meta.itemsPerPage ?? 0,
            totalItems: data?.meta.totalItems ?? 0,
          }}
        />
      </Box>
    </Container>
  );
}

export default AcordoListagemPage;
